import {Locale} from '@/utils/constants'
import {Jurisdiction} from '@/utils/countries/constants'
import {routeTo} from '@/utils/router'

import {getCountryLandingPageData} from './countryCards'
import {
  getLegalServiceCard,
  getMonitoringCard,
  getRegistrationCard,
  getTmRenewalCard,
} from './e2eBrandProtectionCards'

export const getCountrySpecificContent = (countryCode: Jurisdiction, language: Locale) => {
  const isEnLanguage = language === Locale.en

  const country = countryCode?.toLowerCase()
  const verificationLink = {
    pathname: routeTo.verification.form(),
    query: {
      countrySpecific: country,
      country: country,
    },
  }

  const pricingLink = {
    pathname: routeTo.pricing(),
    query: {
      countrySpecific: country,
    },
  }

  const landingPageData = getCountryLandingPageData(countryCode)

  return {
    metaTitle: `country-landing.${country}-lp-meta-title`,
    metaDescription: `country-landing.${country}-lp-meta-desc`,
    hero: {
      title: `country-landing.${country}-lp-hero-title`,
      subtitle: 'homepage-hero-subtitle',
      imageSrc: landingPageData?.imageSrc,
      imageAlt: landingPageData?.imageAlt,
      isIceCream: landingPageData?.isIceCream,
      priceNote: `${country}-lp-hero-price-note`,
      primaryButtonText: 'button-start-with-lawyer-check',
      primaryButtonLink: verificationLink,
      pricingButtonText: 'button-show-price-list',
      pricingButtonLink: pricingLink,
      list: ['hero-list-item-0', 'hero-list-item-1', 'hero-list-item-2'],
    },
    cards: [
      getRegistrationCard(
        verificationLink,
        `country-landing.${country}-lp-protection-card-registration-desc`,
      ),
      getLegalServiceCard(),
      {...(isEnLanguage ? getMonitoringCard() : getTmRenewalCard())},
    ],
    countriesOffer: {
      description: `country-landing.${country}-lp-offering-all-countries-desc`,
    },
    howItWorks: {
      title: 'how-it-works-title',
      description: country === 'us' ? 'country-landing.us-lp-how-it-works-description' : undefined,
      steps: [
        {
          title: 'marketing-pages-common.how-it-works-step-title-0',
          duration: 'marketing-pages-common.how-it-works-step-duration-0',
          description: 'marketing-pages-common.how-it-works-step-desc-0',
          iconSrc: '/images/icons/verification-step.svg',
          iconAlt: 'Trademark verification',
        },
        {
          title: 'marketing-pages-common.how-it-works-step-title-1',
          duration: 'marketing-pages-common.how-it-works-step-duration-1',
          description: 'marketing-pages-common.how-it-works-step-desc-1',
          iconSrc: '/images/icons/drafting-step.svg',
          iconAlt: 'Filling the registration',
        },
        {
          title: `country-landing.${country}-lp-how-it-works-step-title-2`,
          duration: `country-landing.${country}-lp-how-it-works-step-duration-2`,
          description: `country-landing.${country}-lp-how-it-works-step-desc-2`,
          iconSrc: '/images/icons/assessment-step.svg',
          iconAlt: 'Assessment by the trademark office',
        },
        {
          title: 'marketing-pages-common.how-it-works-step-title-3',
          duration: 'marketing-pages-common.how-it-works-step-duration-3',
          description: 'marketing-pages-common.how-it-works-step-desc-3',
          iconSrc: '/images/icons/validity.svg',
          iconAlt: 'Trademark certificate',
        },
      ],
    },
    whyRegisterTm: {
      title: 'tm-importance-title',
      benefits: [
        {
          title: 'country-landing.country-spec-why-reg-tm-0-title',
          description: 'country-landing.country-spec-why-reg-tm-0-desc',
          imageSrc: '/images/flower.svg',
          imageAlt: 'Flower',
        },
        {
          title: 'country-landing.country-spec-why-reg-tm-1-title',
          description: 'country-landing.country-spec-why-reg-tm-1-desc',
          imageSrc: '/images/umbrella.svg',
          imageAlt: 'Umbrella',
        },
      ],
    },
    whyTrama: {
      title: 'country-landing.uk-lp-why-trama-title',
      subtitle: 'country-landing.uk-lp-why-trama-subtitle',
      benefits: [
        {
          title: 'country-landing.uk-lp-why-trama-item-title-0',
          description: 'country-landing.uk-lp-why-trama-item-desc-0',
        },
        {
          title: 'country-landing.uk-lp-why-trama-item-title-1',
          description: 'country-landing.uk-lp-why-trama-item-desc-1',
        },
        {
          title: 'country-landing.uk-lp-why-trama-item-title-2',
          description: 'country-landing.uk-lp-why-trama-item-desc-2',
        },
        {
          title: 'country-landing.uk-lp-why-trama-item-title-3',
          description: 'country-landing.uk-lp-why-trama-item-desc-3',
        },
        {
          title: 'country-landing.uk-lp-why-trama-item-title-4',
          description: 'country-landing.uk-lp-why-trama-item-desc-4',
        },
        {
          title: 'country-landing.uk-lp-why-trama-item-title-5',
          description: 'country-landing.uk-lp-why-trama-item-desc-5',
        },
      ],
    },
    getStartedBanner: {
      title: 'get-started-banner-title',
      buttonLink: verificationLink,
      buttonText: 'get-started-banner-button',
    },
  }
}
